import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchAccount } from "../../features/account/slice";
import { setToken } from "../../features/system/slice";
import { TOKEN_KEY } from "../../utils";

export function RouteChangeListener() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation();
  const { pathname } = location;
  const { token } = useSelector(state => state.system)
  const localToken = localStorage.getItem(TOKEN_KEY)

  useEffect(() => {
    if(localToken){
      if(token === null){
        dispatch(setToken(localToken))
      } else {
        if(localToken !== token){
          dispatch(fetchAccount())
          dispatch(setToken(localToken))
          toast.info('You are redirected to the homepage due to credential changes.')
          history.push('/')
        }
      }
    }
  }, [dispatch, history, localToken, token, location])

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname])

  return null;
}
